module.exports = __webpack_public_path__ + "media/images/wfc/city-7-f3f09af9aac5b3e7574ec4f4c63fbf69.jpg";